import { Component } from '@angular/core';
import { Loader, LucideAngularModule } from "lucide-angular";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: 'app-loading-overlay',
    imports: [
        LucideAngularModule,
        TranslatePipe
    ],
  templateUrl: './loading-overlay.component.html',
  styleUrl: './loading-overlay.component.css'
})
export class LoadingOverlayComponent {

  protected readonly Loader = Loader;
}
